// extracted by mini-css-extract-plugin
export default {"content":"brhHhWK17sZigq2zU0oq","title":"GEKjwzVSxYYhfAOys9Hx","subtitle":"KHTqWdxOde8noVvrMqCg","pillsContainer":"hOBjyd0JLoP3bYxoOAy9","buttonContainer":"wAPpDnjTJZ2_fR4GrWvB"};